"use strict";
import { useQuery } from "@tanstack/react-query";
export const TOPAZ_ID_BASE_URL = process.env.REACT_APP_TOPAZ_ID_BASE_URL?.trim() || "https://id.topazdex.com";
export async function fetchTopazIdProfile(wallet) {
  const res = await fetch(`${TOPAZ_ID_BASE_URL}/api/v1/profile/${wallet}`);
  if (!res.ok) {
    return null;
  }
  return await res.json();
}
export function useTopazIdProfile(wallet) {
  const normalized = wallet?.toLowerCase();
  return useQuery({
    queryKey: ["topaz-id-profile", normalized],
    queryFn: () => fetchTopazIdProfile(normalized),
    enabled: Boolean(normalized),
    staleTime: 6e4,
    retry: 1
  });
}
export function topazIdName(profile) {
  if (!profile?.found) {
    return void 0;
  }
  if (profile.handle) {
    return `@${profile.handle}`;
  }
  return profile.name ?? void 0;
}
export function topazIdAvatar(profile) {
  if (!profile?.found) {
    return void 0;
  }
  return profile.image ?? void 0;
}
export function topazIdProfileUrl(wallet) {
  return `${TOPAZ_ID_BASE_URL}/u/${wallet}`;
}
export const TOPAZ_ID_SETTINGS_URL = `${TOPAZ_ID_BASE_URL}/settings`;
